const gsapAnimations = require("./stories/assets/scripts/animate-universal");

module.exports = {
    initAnimations: function() {
        gsapAnimations()
    }
};
